export enum MenuLevel {
  Root = 1,
  SecondLevel = 5,
  ThirdLevel = 9
}
